<template>
    <div>
        <b-overlay :show="show" :variant="variant" :opacity="opacity" :blur="blur" rounded="lg" spinner-variant="primary">
            <div v-if="showAdmin == 'admin'" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-2/5 sm:m-0 m-4">
                    <div class="mb-5" id="logo_image">
                        <img class="radius" :src="get_logo" :width="'200px'" />
                    </div>
                    <b-card>
                        <div class="pl-4 pr-4">
                            <h2 :style="textColor">{{ $t("BowserNotSupported") }}</h2>
                            <h2 class="mt-5" :style="textColor">{{ $t("SupportedBrowsers") }}</h2>
                            <div class="vx-row mt-5 pl-5 pr-5">
                                <div class="pt-2 vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 text-center">
                                    <div @click="redirectToDownload('chrome')" class="browser-icon">
                                        <img :src="chrome_path" alt="alt" width="100px">
                                        <div><b class="text-white mb-2" v-html="$t('InstallGoogleChrome')"></b></div>
                                    </div>
                                </div>
                                <div class="pt-2 vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 text-center">
                                    <div @click="redirectToDownload('mozilla')" class="browser-icon">
                                        <img :src="firefox_path" alt="alt" width="100px">
                                        <div><b class="text-white mb-2" v-html="$t('InstallMozillaFirefox')"></b></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
                    <div class="vx-row mt-5" id="logo_image">
                        <div class="w-1/2">
                            <strong class="float-right mt-1">{{ $t("Language") }}:</strong>
                        </div>
                        <div class="w-1/2">
                            <i18n class="ml-2" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="confhub">
                <div class="float-right is_footer_false mb-10">
                    <i18n class="float-left" />
                </div>
                <br />
                <b-card class="mt-2">
                    <div class="profile-header app-details">
                        <div class="relative">
                            <div class="pointer-events-none" v-if="company_name">
                                <div>
                                    <b-avatar class="user-profile-img img-center" :src="profile_image" size="85px"></b-avatar>
                                </div>
                            </div>
    
                            <br />
                            <div class="text-center">
                                <h4 :style="textColor">{{ company_name }}</h4>
                                <p :style="textColor">{{ company_description }}</p>
                                <div v-if="company_name" class="border-top"></div>
                                <div class="appointment-details" :style="textColor">
                                    <div class="mt-10 pl-4 pr-4">
                                        <p class="bowser-not-supported-title" :style="textColor">{{ $t("BowserNotSupported") }}</p>
                                        <p class="bowser-not-supported-title mt-5" :style="textColor">{{ $t("SupportedBrowsers") }}</p>
                                        <div class="vx-row mt-5 pl-5 pr-5">
                                            <div class="pt-2 vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 text-center">
                                                <div @click="redirectToDownload('chrome')" class="browser-icon-user">
                                                    <img :src="chrome_path" alt="alt" width="100px">
                                                    <div><b class="mb-2" v-html="$t('InstallGoogleChrome')"></b></div>
                                                </div>
                                            </div>
                                            <div class="pt-2 vx-col w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 text-center">
                                                <div @click="redirectToDownload('mozilla')" class="browser-icon-user">
                                                    <img :src="firefox_path" alt="alt" width="100px">
                                                    <div><b class="mb-2" v-html="$t('InstallMozillaFirefox')"></b></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
            </div>
        </b-overlay>
    </div>
</template>

<style>
.vx-navbar-wrapper.navbar-full {
    display: none;
}

.b-avatar>.b-icon {
    width: 90%;
}

.confhub .appointment-details {
    border-top: none !important;
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 50%;
}

.border-top {
    border-top: solid 1px #ccc;
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 50%;
}

.img-center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}

.is_footer_false {
    background-color: white;
    padding: 0px 14px;
    border-radius: 5px;
}

.browser-icon {
    background-color: #7367f0;
    border-radius: 10px;
}

.browser-icon-user {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
}

.bowser-not-supported-title {
    font-size: 20px;
}

.vx-navbar-wrapper.navbar-default {
    display: none;
}

.card {
    width: 100%;
    background: transparent;
}

.card-body {
    border-radius: 10px;
    border: 2px solid white;
}

@media only screen and (max-width: 991px) {
    .confhub .appointment-details,
    .border-top {
        width: 100%;
    }
}
</style>

<script>
import I18n from "@/layouts/components/navbar/components/I18n.vue";
import $ from "jquery";

export default {
    data() {
        return {
            chrome_path: require("@/assets/images/chrome.png"),
            firefox_path: require("@/assets/images/firefox.png"),
            show: false,
            variant: "light",
            opacity: 0.85,
            blur: "2px",
            textColor: {},
            company_name: "",
            company_description: "",
            profile_image: "",
            showAdmin: localStorage.getItem('browser_user_type'),
        };
    },
    computed: {
        get_logo() {
            return this.$store.getters.whitelabel.logo.path;
        },
        background_image() {
            return {
                "background-image": "url(" + this.$store.getters.whitelabel.background_image.path + ")",
            };
        },
    },

    watch: {
        background_image: function(newValue) {},
        get_logo: function(newValue) {},
        "$i18n.locale": {
            handler: function(value) {
                this.loadLocale(value);
                this.displayError();
            },
        },
    },
    components: {
        I18n,
    },

    created() {
        this.getSettings();
        if (localStorage.getItem('staffslug')) {
            this.getDepartmentDetailsBySlug()
        } else if (localStorage.getItem('slug')) {
            this.getCompanyDetails()
        } else if (localStorage.getItem('browser_uuid')) {
            this.getAppointmentByUuid()
        }

        if (localStorage.getItem('browser_user_type') == "admin") {
            setTimeout(() => {
                $('.layout--main.main-vertical.navbar-floating.footer-static').css({ "background-image": "url('" + this.$store.getters.whitelabel.background_image.path + "')", "background-position": "inherit", "background-repeat": "no-repeat", "background-size": "cover", "background-attachment": "fixed" })
                $('.layout--full-page').css({ "background-image": "url('" + this.$store.getters.whitelabel.background_image.path + "')", "background-position": "inherit", "background-repeat": "no-repeat", "background-size": "cover", "background-attachment": "fixed" })
                $('.content-area-reduced').css({ "background-image": "url('" + this.$store.getters.whitelabel.background_image.path + "')", "background-position": "inherit", "background-repeat": "no-repeat", "background-size": "cover","background-attachment": "fixed" })
                $('.the-footer').css({ "display": "none" })
            }, 100);
        }
    },

    methods: {
        getSettings() {
            document.title = "";
            const favicon = document.getElementById("favicon");
            favicon.href = "";
            this.$store
                .dispatch("GetSystemSettings")
                .then((res) => {
                    this.$store.commit("SET_WHITELABEL", res.data.data);
                    document.title = res.data.data.title;
                    favicon.href = res.data.data.favicon_image.path;
                })
                .catch((error) => {
                    return false;
                });
        },

        getAppointmentByUuid() {

            this.$store
                .dispatch("GetAppointmentByUuid", localStorage.getItem('browser_uuid'))
                .then((res) => {
                    this.profile_image = res.data.data.company_profile_image;
                    this.company_name = res.data.data.company_name;
                    this.company_description = res.data.data.welcome_message;
                    this.getCustomStyle(res.data.data.company_id);

                })
        },
        async getDepartmentDetailsBySlug() {

            let data = {
                staffSlug: localStorage.getItem('staffslug'),
                company_slug: localStorage.getItem('slug'),
            };
            const res = await this.$store.dispatch("DepartmentDetailsBySlug", data);

            if (res.data.status == "success") {
                this.profile_image = res.data.data.company_profile_image;
                this.company_name = res.data.data.company_name;
                // this.company_description = res.data.data.welcome_message;
                this.getCustomStyle(res.data.data.company_id)

            }


        },

        async getCompanyDetails() {
            this.show = false;
            const res = await this.$store.dispatch("CompanyDetails", localStorage.getItem('slug'));
            if (res.data.status == "success") {
                this.profile_image = res.data.data.profile_image;
                this.company_name = res.data.data.company_name;
                this.company_description = res.data.data.welcome_message;
                this.getCustomStyle(res.data.data.id);
            }
        },

        getCustomStyle(id) {
            let data = {
                company_id: id
            };
            this.$store
                .dispatch("GetCustomStyle", data)
                .then((res) => {

                    $('.card-body').css({ "background-color": res.data.data.form_background_color })
                    this.textColor = { "color": res.data.data.form_text_color };
                    $(".the-footer p, .the-footer a").css({
                        "color": res.data.data.form_text_color
                    });
                    if (res.data.data.background_images) {
                        $('.layout--main.main-vertical.navbar-floating.footer-static').css({ "background-image": "url('" + res.data.data.background_images.path + "')", "background-position": "center", "background-repeat": "no-repeat", "background-size": "cover", "background-attachment": "fixed" })
                        $('.layout--full-page').css({ "background-image": "url('" + res.data.data.background_images.path + "')", "background-position": "center", "background-repeat": "no-repeat", "background-size": "cover", "background-attachment": "fixed" })
                        $('.content-area-reduced').css({ "background-image": "url('" + res.data.data.background_images.path + "')", "background-position": "center", "background-repeat": "no-repeat", "background-size": "cover", "background-attachment": "fixed" })
                    } else {
                        $('.layout--full-page').css({ "background-image": "none" })
                        $('.content-area-reduced').css({ "background-image": "none" })
                    }

                })
                .catch((error) => {
                    this.$log.error(
                        "File : BookingForm.vue | Function : getCustomStyle() | Error :",
                        error
                    );
                    this.error =
                        this.$t(error.replace(/[\s\/]/g, "")) !==
                        error.replace(/[\s\/]/g, "") ?
                        this.$t(error.replace(/[\s\/]/g, "")) :
                        error;
                    this.$toasted.show(this.error, {
                        className: "top-alert",
                        position: "top-center",
                        type: "error",
                        duration: 2000,
                    });
                    return false;
                });
        },

        redirectToDownload(type) {
            let link = type == 'chrome' ? 'https://www.google.com/chrome/' : 'https://www.mozilla.org/en-US/firefox/new/'
          
            window.open(
                link,
                '_blank' // <- This is what makes it open in a new window.
);
        }
    },
};
</script>